// Options and limits for gate access bookings in the resident portal

export const visitorTypes = [
    "Guest",
    "Family member",
    "Contractor",
    "Delivery or courier",
    "Service provider"
]

export const arrivalWindows = [
    "06:00 to 09:00",
    "09:00 to 12:00",
    "12:00 to 15:00",
    "15:00 to 18:00",
    "18:00 to 22:00",
    "All day"
]

// How far ahead a visitor can be booked, and the largest group per booking
export const BOOKING_DAYS_AHEAD = 90
export const MAX_GUESTS = 20

// Passwords are long rather than complicated
export const MIN_PASSWORD_LENGTH = 10
